<div class="display-flex flex-align-center justify-content full-height">
  <app-card class="w-280">
    <div class="text-center">
      <img alt="Adloop logo" class="w-1-2" src="https://cdn.adloop.co/images/adloop-ca-logo-color.png">
      <p class="baseline">Media Optimization Made Easy</p>
      <ng-content></ng-content>
    </div>
  </app-card>
</div>
